module.exports = __webpack_public_path__ + "static/media/get-refund-image.52a6aa1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/TCH-WEB/get-refund-image.jpg
// module id = 1294
// module chunks = 0